import {
    easeInBounce,
    easeInCubic,
    easeInElastic,
    easeInExpo,
    easeInOutCubic,
    easeInOutElastic,
    easeInOutExpo,
    easeInOutQuad,
    easeInOutQuart,
    easeInOutQuint,
    easeInOutSine,
    easeInQuad,
    easeInQuart,
    easeInQuint,
    easeInSine,
    easeOutBounce,
    easeOutCubic,
    easeOutElastic,
    easeOutExpo,
    easeOutQuad,
    easeOutQuart,
    easeOutQuint,
    easeOutSine,
} from "easing-utils";
import { easeIn, easeInOut, easeOut, backInOut, backIn, backOut, circIn, circInOut, circOut } from "motion";

const customEasings = {
    easeInBounce,
    easeInCubic,
    easeInElastic,
    easeInExpo,
    easeInOutCubic,
    easeInOutElastic,
    easeInOutExpo,
    easeInOutQuad,
    easeInOutQuart,
    easeInOutQuint,
    easeInOutSine,
    easeInQuad,
    easeInQuart,
    easeInQuint,
    easeInSine,
    easeOutBounce,
    easeOutCubic,
    easeOutElastic,
    easeOutExpo,
    easeOutQuad,
    easeOutQuart,
    easeOutQuint,
    easeOutSine,
};

const motionEasings = {
    easeIn,
    easeInOut,
    easeOut,
    backInOut,
    backIn,
    backOut,
    circIn,
    circInOut,
    circOut,
};

export { customEasings, motionEasings };
